module.exports = __webpack_public_path__ + "assets/functionalityTrashSmall-c391af.svg";